var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 .281C3.82.281.531 2.711.531 6.777c0 4.26 6.014 10.322 6.27 10.578a.28.28 0 0 0 .398 0c.256-.256 6.27-6.319 6.27-10.578C13.469 2.71 10.179.28 7 .28ZM7 9a2.25 2.25 0 1 1 0-4.5A2.25 2.25 0 0 1 7 9Z",
    fill: "#3483DF"
  })));
};
export default SvgPin;